import React from 'react';
import PropTypes from 'prop-types';
import { SearchResult } from './search-result';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import classnames from 'clsx';
import style from './style.module.less';

export const ResultList = ({ searchResults, searchTerm, onSelectionMade, dropdownClassName = '' }) => {
  return (
    <div className={classnames(style['result-dropdown-menu'], dropdownClassName)}>
      {searchResults.map((item, idx) => {
        return (
          <div key={idx} className={style['result-item']}>
            <DropdownMenuItem className={style.row} onClick={() => onSelectionMade(item)}>
              <SearchResult key={idx} itemName={item.name} itemSku={item.sku} searchTerm={searchTerm} />
            </DropdownMenuItem>
          </div>
        );
      })}
    </div>
  );
};

ResultList.propTypes = {
  searchResults: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      productId: PropTypes.string,
      sku: PropTypes.string,
    }),
  ).isRequired,
  searchTerm: PropTypes.string.isRequired,
  onSelectionMade: PropTypes.func.isRequired,
  dropdownClassName: PropTypes.string,
};
